export default __webpack_public_path__ + "static/media/001-accountant.efdfd16c.svg";